export const TTS_VOICE_STORAGE_KEY = "reflections_openai_tts_voice";

export const DEFAULT_TTS_VOICE = "nova";

/** OpenAI TTS-1 voices (see https://platform.openai.com/docs/guides/text-to-speech) */
export const OPENAI_TTS_VOICES = [
  { id: "alloy", label: "Alloy" },
  { id: "echo", label: "Echo" },
  { id: "fable", label: "Fable" },
  { id: "onyx", label: "Onyx" },
  { id: "nova", label: "Nova" },
  { id: "shimmer", label: "Shimmer" },
];
